<template>
  <div class="youkuaidi">
       <topTitle title="五有服务" :list="list" :newData="newData"></topTitle>
       <p class="top_p">钱湖柏庭园区配套百亩大型生态农庄，小河至东向西穿园区而过，旨在打造符合长者理想生活的最美农庄。农庄按照四季不同节气科学管理，春天观兰开，夏天可赏荷，秋天看菊落，冬天能折梅。园区还同时为每户家庭设置私人花园农场，喜欢侍弄花草的长者，可根据自己需求进行耕种，也可委托园区工作人员精心打理，使长者重回花田半亩、蛙鸣稻香的年少时光。</p>
        <div class="item_bd">
            <img :src="item.img" alt="" v-for="(item,key) in list2" :key='key'>
        </div>
  </div>
</template>
  <script>
  import topTitle from "../rightTopTitle";
export default {
  name: "youkuaidi",
  data() {
    return {
      list: [
          {
              title: "【五有】有套房",
              small_title: "HAVE A SUITE",
              hasTitle: "有套房",
          },
          {
              title: "【五有】有块地",
              hasTitle: "有块地",
          },
          {
              title: "【五有】有地暖",
              hasTitle: "有地暖",
          },
          {
              title: "【五有】有社团",
              small_title: "HAVE A CLUB",
              hasTitle: "有社团",
          },
          {
              title: "【五有】有管家",
              small_title: "HAVE A BUTLER",
              hasTitle: "有管家",
          }
      ],
      newData: 1,
        list2:[{
            img:require('../../assets/image/fuwu/kuaidi.jpeg')
        }]
    };
  },
  methods: {},
  mounted: function() {},
  components: {
      topTitle
  },
   props: {
   
  },
};
</script>
<style scoped="scoped">
.youkuaidi{
    width: 100%;
    height: 100%;

}
.top_p {
margin-top: 0.6625rem;
 text-align: left;
font-size: 0.35rem;
font-family: PingFang SC;
font-weight: 400;
color: #222222;
line-height: 0.675rem;
text-indent: 2em;
}
.item_bd{
    margin-top: 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item_bd img{
    width:100%;
/* height: 6.3375rem; */
border-radius: 0.125rem;

}
</style>